import React, { Component } from "react";
import helpers from "../../../helpers";
import { calculatePages } from './settings.js';
const moment = require("moment");
moment.updateLocale("en", {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: () => "a moment",
  },
});

import Info from "./info";
import Settings from "./settings";
import JobFinished from "./jobFinished";
import JobFailed from "./jobFailed";
// import CardForm from "../../menus/CardForm";
import ReloadBalance from "../../menus/ReloadBalance";

import "../../../plugins/swipebook-pdf-viewer/css/flipbook.style.css";
require("../../../plugins/swipebook-pdf-viewer/js/flipbook.js");

class Printer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      user: props.user,
      client: props.client,
      printerRef: props.printerRef,
      printer: props.printer,
      service: {},
      services: {},
      loader: false,
      scan: false,
      print: false,
      copy: false,
      pdfUrl: "",
      pdf: "",
      scanner: false,
      computerUser: {},
      files: [],
      action: "",
      finishedJob: {},
      failedJob: {},
      pages: null,
      uploading: false,
      converting: false,
      uploadProgress: 0,
      // allowed: false,
      allowed: true,
      printCost: undefined,
      initializing: true,
    };

    this.settings = React.createRef();
    this.onChangeFile = this.onChangeFile.bind(this);
    this.serviceSubscription;
    this.pagesInterval;
  }

  async onChangeFile(e) {
    let file = e.target.files[0];
    let content_type = "binary/octet-stream";
    if (file) {
      this.setState({ loader: true });
      let file_extension = file.name.split(".").pop().toLowerCase();
      let response = await helpers.serviceRequest("getPreSignedUrl", {
        file_extension,
        content_type,
      });
      let presigned_url = response.presigned_url;
      let path = helpers.getPathFromUrl(presigned_url);
      try {
        this.setState({ uploading: true, uploadProgress: 0 });
        await helpers.putObject(presigned_url, file, (percent) => {
          this.setState({ uploadProgress: percent });
        });
        this.setState({ uploading: false, converting: true });
        const pdfKey = await helpers.serviceRequest("print2pdf", {
          file: path,
        });
        this.setState({ converting: false });
        if (typeof pdfKey === "string") {
          await helpers.addFileToUser({
            userRef: this.state.app.state.userRef,
            file: pdfKey,
          });

          const pdfResponse = await helpers.serviceRequest("downloadPdf", {
            key: `documents/${pdfKey}.pdf`,
          });
          const pdf = pdfResponse.presigned_url;
          this.setPdf(pdf);
        } else {
          const currentPdf = `${this.state.files[0].path}.pdf`;
          this.choosePdf(currentPdf);
        }
      } catch (e) {
        console.log(e);
      }
      this.setState({ loader: false });
    }
  }

  async startAction(action) {
    // console.log("startAction() called with action:", action);
    helpers.closeMenu();
    if (action) {
      if (!this.state.computerUser) {
        console.error("computerUser data missing when starting action");
        this.showDataErrorMessage();
        return;
      }
      
      if (action === 'print') {
        const { pricing } = this.state.computerUser || {};
        console.log("Pricing data:", pricing);
        console.log("User balance:", this.state.app.state.client.balance);
        
        const { settings } = this.settings.current.state;
        let printCost = 0;
        if (pricing) {
          const priceAmount = settings.color ? pricing.print.color : pricing.print.bw;
          printCost = (priceAmount || 0) * (settings.pages ? calculatePages(settings.pages) || this.state.pages  || 1: this.state.pages || 1) * (settings.copies || 1);
          printCost = Math.round(printCost * 100) / 100;
          this.setState({ printCost });
          
          // console.log("Print cost calculation:", {
          //   priceAmount,
          //   pages: settings.pages ? calculatePages(settings.pages) || this.state.pages || 1 : this.state.pages || 1,
          //   copies: settings.copies || 1,
          //   finalPrintCost: printCost,
          //   userBalance: this.state.app.state.client.balance && this.state.app.state.client.balance.amount,
          //   hasCredits: !!this.state.app.state.client.credits
          // });
          
          const hasInsufficientBalance = 
            this.state.app.state.client.balance && 
            this.state.app.state.client.balance.amount < printCost && 
            !this.state.app.state.client.credits;
            
          // console.log("Balance check:", {
          //   hasBalance: !!this.state.app.state.client.balance,
          //   balanceAmount: this.state.app.state.client.balance && this.state.app.state.client.balance.amount,
          //   printCost,
          //   isLessThan: this.state.app.state.client.balance && this.state.app.state.client.balance.amount < printCost,
          //   hasCredits: !!this.state.app.state.client.credits,
          //   hasInsufficientBalance
          // });
            
          if (hasInsufficientBalance) {
            console.log("Insufficient balance detected, showing reload popup");
            helpers.activateMenu("reload-balance");
            return;
          }
        } else {
          console.error("Pricing data missing for print action");
          this.showDataErrorMessage();
          return;
        }
      } else {
        console.log("startAction() called with non-print action:", action);
      }

      let timeoutTimer;
      const timeout = () => {
        let seconds = 0;
        let busy = false;
        timeoutTimer = setInterval(() => {
          seconds++;
          switch (action) {
            case "print":
              if (
                this.state.service.printer.state.toLowerCase() == "processing"
              )
                busy = true;
              break;
            case "scan":
            case "copy":
              if (
                this.state.service.scanner.state.toLowerCase() == "processing"
              )
                busy = true;
              break;
          }
          const progressVal = Number($("#ring-progress").text());
          if (busy || progressVal > 0) clearInterval(timeoutTimer);
          else if (seconds >= 60) {
            clearInterval(timeoutTimer);
            let state = {};
            state[action] = false;
            this.setState(state);
          }
        }, 1000);
      };

      const jobFailed = () => helpers.activateMenu("menu-job-failed");

      timeout();
      try {
        await this[action]();
        setTimeout(async () => {
          const response = await helpers.serviceRequest("getJobs", {
            clients: [this.state.app.state.userRef.id],
            offset: 0,
            limit: 1,
          });
          const lastJob = response[0];
          if (
            lastJob &&
            new Date().getTime() - Date.parse(lastJob.time) <= 15000
          ) {
            this.setState({ finishedJob: lastJob });
            helpers.activateMenu("menu-job-finished");
          } else {
            this.setState({ failedJob: { action } });
            jobFailed();
          }
        }, 1000);
      } catch (e) {
        console.log(e);
        this.setState({ failedJob: { action } });
        jobFailed();
      }
      this.setState({ action: null });
    }
  }

  topUpAndReturn(printCost) {
    const action = this.state.action;
    this.setState({ printCost });
    helpers.activateMenu("reload-balance");
    const paymentInterval = setInterval(() => {
      if (!$("#reload-balance").hasClass("menu-active")) {
        clearInterval(paymentInterval);
      } else if (
        this.state.app.state.client.balance &&
        this.state.app.state.client.balance.amount >= printCost
      ) {
        clearInterval(paymentInterval);
        helpers.closeMenu();
        this.setState({ action });
        helpers.activateMenu("menu-settings-bottom");
      }
    }, 250);
  }

  async action(x) {
    if (!this.state.computerUser) {
      console.error("computerUser data missing in action method");
      this.showDataErrorMessage();
      return;
    }
    
    const beforeAction = async (x) => {
      // console.log("beforeAction() called, opening settings menu for action:", x);
      this.setState({ action: x });
      const menuId = "menu-settings-bottom";
      helpers.activateMenu(menuId);
      // console.log("Settings menu activated:", menuId);
      let actionInterval = setInterval(async () => {
        if (!$(`#${menuId}`).hasClass("menu-active")) {
          // console.log("Settings menu closed, clearing action");
          clearInterval(actionInterval);
          this.setState({ action: "" });
        }
      }, 250);
    };

    const { pricing } = this.state.computerUser;
    const { settings } = this.settings.current.state;
    let printCost = 0;
    if (pricing) {
      const priceAmount = settings.color ? pricing.print.color : pricing.print.bw;
      printCost = (priceAmount || 0) * (settings.pages ? calculatePages(settings.pages) || this.state.pages  || 1: this.state.pages || 1) * (settings.copies || 1);
      printCost = Math.round(printCost * 100) / 100;
      this.setState({ printCost });
      
      // console.log("action() method - Print cost calculation:", {
      //   priceAmount,
      //   pages: settings.pages ? calculatePages(settings.pages) || this.state.pages || 1 : this.state.pages || 1,
      //   copies: settings.copies || 1,
      //   finalPrintCost: printCost,
      //   userBalance: this.state.app.state.client.balance && this.state.app.state.client.balance.amount,
      //   hasCredits: !!this.state.app.state.client.credits
      // });
    }

    const reloadBalance = (x) => {
      helpers.activateMenu("reload-balance");
      let paymentInterval = setInterval(async () => {
        if (!$("#reload-balance").hasClass("menu-active")) {
          clearInterval(paymentInterval);
        } else if (this.state.app.state.client.balance && this.state.app.state.client.balance.amount > 0 && (x !== "print" || this.state.app.state.client.balance.amount >= printCost)) {
          clearInterval(paymentInterval);
          helpers.closeMenu();
          beforeAction(x);
        }
      }, 250);
    };

    const balanceCheck = this.state.app.state.client.balance && this.state.app.state.client.balance.amount > 0 && (x !== "print" || this.state.app.state.client.balance.amount >= printCost);
    const creditsCheck = this.state.client && this.state.client.credits;
    const noPricingCheck = !this.state.computerUser.pricing;
    
    // console.log("action() method - Final balance check:", {
    //   action: x,
    //   userBalance: this.state.app.state.client.balance && this.state.app.state.client.balance.amount,
    //   printCost,
    //   balanceCheck,
    //   creditsCheck,
    //   noPricingCheck,
    //   willProceed: balanceCheck || creditsCheck || noPricingCheck
    // });
    
    if (balanceCheck || creditsCheck || noPricingCheck) {
      beforeAction(x);
    } else {
      reloadBalance(x);
    }
  }

  async print(copy = false) {
    return new Promise(async (resolve, reject) => {
      try {
        if (!copy) this.setState({ print: true });
        const response = await helpers.serviceRequest("MFPRequest", {
          action: "print",
          client: this.state.user.uid,
          copy,
          printer: this.state.printerRef.path,
          pdf: this.state.pdf,
          settings: this.settings.current.state.settings,
        });
        if (response) {
          await helpers.getMFPResponse(this, response.serviceRef, response.id);
          resolve();
        } else {
          reject();
        }
        this.setState({ print: false, copy: false });
      } catch (e) {
        reject(e);
      }
    });
  }

  async scan(copy = false) {
    return new Promise(async (resolve, reject) => {
      try {
        let response;
        if (!copy) {
          this.setState({ scan: true });
        }
        response = await helpers.serviceRequest("MFPRequest", {
          action: "scan",
          client: this.state.user.uid,
          copy,
          printer: this.state.printerRef.path,
          settings: this.settings.current.state.settings,
        });
        if (response) {
          this.setState({
            pdf: await helpers.getMFPResponse(
              this,
              response.serviceRef,
              response.id
            ),
          });
          let pdf = await helpers.serviceRequest("downloadPdf", {
            key: this.state.pdf,
          });
          this.setPdf(pdf.presigned_url, copy);
          if (!copy) {
            this.setState({ loader: false });
          }
        }
        this.setState({ scan: false });
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  async copy() {
    return new Promise(async (resolve, reject) => {
      try {
        this.setState({ copy: true });
        const response = await helpers.serviceRequest("MFPRequest", {
          action: "copy",
          client: this.state.user.uid,
          printer: this.state.printerRef.path,
          settings: this.settings.current.state.settings,
        });
        if (response)
          await helpers.getMFPResponse(this, response.serviceRef, response.id);
        this.setState({ copy: false });
        resolve();
      } catch (e) {
        reject(e);
      }
    });
  }

  save() {
    window.open(this.state.pdfUrl, "_self");
  }

  setPdf(pdfUrl, copy = false, welcome = false) {
    if (pdfUrl) {
      const pdf = helpers.getPathFromUrl(pdfUrl);
      this.setState({
        pdfUrl,
        pdf,
        pages: null,
      });
    }
    if (!welcome && !copy) {
      this.setState({ loader: false });
    }
    $("#book").html("").swipeBook({
      hideMenu: true,
      backgroundColor: "#ccc",
      pdfUrl: this.state.pdfUrl,
    });
    if (this.pagesInterval) clearInterval(this.pagesInterval);
    this.pagesInterval = setInterval(() => {
      const $currentPageNumber = $(".flipbook-currentPageNumber");
      if ($currentPageNumber.length > 0) {
        if (this.pagesInterval) clearInterval(this.pagesInterval);
        const pages = Number(
          $(".flipbook-currentPageNumber").text().split("/")[1].trim()
        );
        this.setState({ pages });
      }
    }, 100);
  }

  async remove() {
    await helpers.removeFileFromUser({
      userRef: this.state.app.state.userRef,
      file: this.state.pdf,
    });
    const lastPdf = this.state.pdf;
    $("#book").html("");
    const filesInterval = setInterval(() => {
      if (this.state.files.length >= 1) {
        const currentPdf = `${this.state.files[0].path}.pdf`;
        if (lastPdf != currentPdf) {
          this.choosePdf(currentPdf);
          clearInterval(filesInterval);
        }
      } else {
        this.setState({ pdf: null });
        clearInterval(filesInterval);
      }
    }, 100);
  }

  printerBack() {
    this.state.app.change("main");
  }

  setPic() {
    return new Promise(async (resolve, reject) => {
      try {
        let pic = await helpers.downloadPic(this);
        this.setState({ pic });
        if (window.mobileDebug) window.mobileDebug("setPic completed");
        resolve(pic);
      } catch (error) {
        if (window.mobileDebug) window.mobileDebug("setPic error:", error.message);
        // Still resolve with null to prevent hanging
        resolve(null);
      }
    });
  }

  getService() {
    return new Promise((resolve, reject) => {
      try {
        if (!this.state.printerRef || !this.state.printerRef.parent) {
          if (window.mobileDebug) window.mobileDebug("Invalid printer reference in getService");
          resolve(null);
          return;
        }
        
        this.serviceSubscription = this.state.printerRef.parent.parent
          .collection("service")
          .doc(this.state.printerRef.id)
          .onSnapshot((snapshot) => {
            if (snapshot.exists) {
              const service = snapshot.data();
              const available =
                service.active && (service.printer || service.scanner);
              this.setState({ service, available });
              if (window.mobileDebug) window.mobileDebug("Service data received");
            } else {
              if (window.mobileDebug) window.mobileDebug("Service snapshot doesn't exist");
            }
            resolve(true);
          }, (error) => {
            if (window.mobileDebug) window.mobileDebug("getService onSnapshot error:", error.message);
            resolve(null); // Resolve anyway to prevent hanging
          });
      } catch (error) {
        if (window.mobileDebug) window.mobileDebug("getService setup error:", error.message);
        resolve(null); // Resolve anyway to prevent hanging
      }
    });
  }

  async choosePdf(key) {
    const pdfUrl = await helpers.serviceRequest("downloadPdf", { key });
    this.setPdf(pdfUrl.presigned_url);
  }

  getServices() {
    return new Promise(async (resolve, reject) => {
      try {
        if (!this.state.printerRef) {
          if (window.mobileDebug) window.mobileDebug("Invalid printer reference in getServices");
          resolve(null);
          return;
        }
        
        let servicesCollection = await this.state.printerRef
          .collection("services")
          .get();
        let services = {};
        servicesCollection.forEach((serviceDoc) => {
          services[serviceDoc.id] = serviceDoc.data();
        });
        this.setState({ services });
        if (window.mobileDebug) window.mobileDebug("Services data received:", Object.keys(services));
        resolve(services);
      } catch (error) {
        if (window.mobileDebug) window.mobileDebug("getServices error:", error.message);
        // Still resolve with empty object to prevent hanging
        resolve({});
      }
    });
  }

  componentDidMount() {
    // Initialize Eruda for mobile debugging only if debug parameter is present in URL
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('debug')) {
      const script = document.createElement('script');
      script.src = "https://cdn.jsdelivr.net/npm/eruda";
      document.body.appendChild(script);
      script.onload = function() {
        eruda.init();
        console.log(`Debug mode activated, version v1.3.24`);
        // Log additional browser info to help with debugging
        console.log("Browser info:", {
          userAgent: navigator.userAgent,
          platform: navigator.platform,
          vendor: navigator.vendor,
          language: navigator.language
        });
        
        // Add a visible debug panel for mobile testing
        const debugPanel = document.createElement('div');
        debugPanel.id = 'mobile-debug-panel';
        debugPanel.style = `
          position: fixed;
          bottom: 200px;
          right: 10px;
          background: rgba(0,0,0,0.8);
          color: #00ff00;
          padding: 10px;
          border-radius: 5px;
          font-size: 12px;
          z-index: 9999;
          max-width: 80%;
          max-height: 200px;
          overflow: auto;
        `;
        document.body.appendChild(debugPanel);
        
        // Add a global debug function that writes to both console and screen
        window.mobileDebug = function(msg, data) {
          const logMsg = typeof data !== 'undefined' ? `${msg}: ${JSON.stringify(data)}` : msg;
          console.log(logMsg);
          
          const panel = document.getElementById('mobile-debug-panel');
          if (panel) {
            const entry = document.createElement('div');
            entry.textContent = logMsg;
            entry.style.borderBottom = '1px solid #333';
            entry.style.paddingBottom = '3px';
            entry.style.marginBottom = '3px';
            panel.appendChild(entry);
            
            // Keep only the last 10 messages
            while (panel.children.length > 10) {
              panel.removeChild(panel.firstChild);
            }
          }
        };
        
        // Test the debug function
        window.mobileDebug('Debug panel initialized');
        
        // Safe start of component lifecycle
        try {
          window.mobileDebug('Triggering componentWillMount manually');
          // Force componentWillMount to run again if it failed earlier
          setTimeout(() => {
            try {
              this.componentWillMount();
            } catch (e) {
              window.mobileDebug('Error in manual componentWillMount', e.message);
            }
          }, 500);
        } catch (e) {
          window.mobileDebug('Error in eruda onload', e.message);
        }
      }.bind(this); // Important: bind 'this' to access component methods
    }
    
    // Also add a function to test Firebase connectivity
    this.testFirebaseConnectivity();
  }

  async testFirebaseConnectivity() {
    try {
      // Check if we can get any data from Firestore
      if (this.state.printerRef) {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('debug') && window.mobileDebug) {
          window.mobileDebug('Testing Firebase connectivity');
          window.mobileDebug('Printer ref path', this.state.printerRef.path);
          
          // Try a simple read operation
          const snapshot = await this.state.printerRef.get();
          window.mobileDebug('Printer snapshot exists', snapshot.exists);
          
          if (snapshot.exists) {
            const data = snapshot.data();
            window.mobileDebug('Printer data keys', Object.keys(data));
          }
        }
      }
    } catch (error) {
      if (window.mobileDebug) {
        window.mobileDebug('Firebase test error', error.message);
      } else {
        console.error('Firebase test error:', error);
      }
    }
  }

  async componentWillMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const debug = urlParams.has('debug');
    
    // Use our new debug function if available
    const log = (window.mobileDebug || console.log);
    
    log("componentWillMount started");
    
    // First, ensure printer reference exists
    if (!this.state.printerRef) {
      log("Error: printer reference missing");
      this.showDataErrorMessage();
      this.setState({ initializing: false });
      return;
    }
    
    try {
      // Quick Firebase connectivity test to check if that's the issue
      log("Testing Firebase connectivity");
      try {
        const quickTestPromise = this.state.printerRef.get();
        const quickTestTimeout = new Promise((_, reject) => 
          setTimeout(() => reject(new Error("Quick Firebase test timeout")), 3000)
        );
        const snapshot = await Promise.race([quickTestPromise, quickTestTimeout]);
        log("Firebase connectivity confirmed:", snapshot.exists);
      } catch (e) {
        log("Firebase connectivity test failed:", e.message);
        // Continue anyway - the main operations will timeout if needed
      }

      // PARALLEL LOADING: Run all initial operations in parallel
      log("Starting parallel loading of initial data");
      
      // Create promises with timeouts
      const picPromise = Promise.race([
        this.setPic(),
        new Promise((_, reject) => setTimeout(() => reject(new Error("setPic timeout")), 10000))
      ]).catch(error => {
        log("setPic error:", error.message);
        return null; // Return null on error so Promise.all continues
      });
      
      const servicePromise = Promise.race([
        this.getService(),
        new Promise((_, reject) => setTimeout(() => reject(new Error("getService timeout")), 10000))
      ]).catch(error => {
        log("getService error:", error.message);
        return null; // Return null on error so Promise.all continues
      });
      
      const servicesPromise = Promise.race([
        this.getServices(),
        new Promise((_, reject) => setTimeout(() => reject(new Error("getServices timeout")), 10000))
      ]).catch(error => {
        log("getServices error:", error.message);
        return null; // Return null on error so Promise.all continues
      });
      
      // Run all three operations in parallel
      log("Waiting for parallel operations to complete");
      const [picResult, serviceResult, servicesResult] = await Promise.all([
        picPromise,
        servicePromise,
        servicesPromise
      ]);
      
      log("Parallel operations completed", {
        picResult: picResult ? "success" : "failed",
        serviceResult: serviceResult ? "success" : "failed",
        servicesResult: servicesResult ? "success" : "failed"
      });
      
      // Check scanner state after parallel loading
      try {
        if (
          this.state.services && this.state.services.wsd &&
          this.state.services.wsd.scanner &&
          this.state.service && this.state.service.scanner
        ) {
          this.setState({ scanner: true });
          log("Scanner set to true");
        } else {
          log("Scanner conditions not met:", {
            hasServices: !!this.state.services,
            hasWsd: !!(this.state.services && this.state.services.wsd),
            hasScanner: !!(this.state.services && this.state.services.wsd && this.state.services.wsd.scanner),
            hasServiceScanner: !!(this.state.service && this.state.service.scanner)
          });
        }
      } catch (e) {
        log("Error setting scanner state:", e.message);
      }

      // PARALLEL LOADING: Load computer user data in parallel with UI rendering
      // This operation isn't strictly required for initial UI display
      log("Starting computer user data loading");
      this.loadComputerUserData().catch(error => {
        log("Computer user data loading failed:", error.message);
      }).finally(() => {
        // Set initializing to false whether computer user data loads or not
        // This allows the UI to be usable even if some data is still loading
        log("All critical initialization complete");
        this.setState({ initializing: false });
      });
      
    } catch (error) {
      log("Critical error in componentWillMount:", error.message);
      this.showDataErrorMessage();
      this.setState({ initializing: false });
    }
  }

  // Separate method for loading computer user data
  // This allows us to load it in parallel without blocking UI rendering
  async loadComputerUserData() {
    const log = (window.mobileDebug || console.log);
    
    try {
      // Check if reference is valid
      if (!this.state.printerRef || !this.state.printerRef.parent) {
        log("Invalid printer reference structure");
        throw new Error("Invalid printer reference");
      }
      
      const computerRef = this.state.printerRef.parent.parent;
      log("Computer reference path:", computerRef.path);
      
      // Add timeout for computer ref get operation
      const timeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error("computerRef.get timeout")), 10000)
      );
      const computerSnapshotPromise = computerRef.get();
      const computerSnapshot = await Promise.race([computerSnapshotPromise, timeoutPromise]);
      
      log("Computer snapshot exists:", computerSnapshot.exists);
      
      if (!computerSnapshot.exists) {
        log("Computer snapshot doesn't exist");
        throw new Error("Computer snapshot missing");
      }
      
      const computerData = computerSnapshot.data();
      log("Computer data keys:", computerData ? Object.keys(computerData) : "no data");
      log("Has user reference:", !!(computerData && computerData.user));
      
      if (!computerData || !computerData.user) {
        log("Computer data or user reference missing");
        throw new Error("Computer user reference missing");
      }
      
      log("Getting computer user document");
      // Wrap the get operation in try/catch with timeout
      const userTimeoutPromise = new Promise((_, reject) => 
        setTimeout(() => reject(new Error("computerData.user.get timeout")), 10000)
      );
      const computerUserRefPromise = computerData.user.get();
      const computerUserRef = await Promise.race([computerUserRefPromise, userTimeoutPromise]);
      
      log("Computer user reference exists:", computerUserRef.exists);
      
      if (!computerUserRef.exists) {
        log("Computer user reference doesn't exist");
        throw new Error("Computer user document missing");
      }
      
      const computerUserData = computerUserRef.data();
      log("Computer user data loaded successfully");
      log("Pricing available:", !!(computerUserData && computerUserData.pricing));
      
      this.setState({ computerUser: computerUserData, computerUserRef });
      log("Computer user state updated successfully");
      
      return computerUserData;
    } catch (error) {
      log("Error loading computer user data:", error.message);
      throw error; // Rethrow to be handled by the caller
    }
  }

  async componentDidUpdate() {
    const clientFiles = this.state.app.state.client.files || [];
    const clientFilesIds = clientFiles.map((clientFile) => clientFile.id);
    if (
      clientFiles &&
      JSON.stringify(clientFilesIds) !=
        JSON.stringify(this.state.clientFilesIds)
    ) {
      this.setState({ clientFilesIds });
      let files = await helpers.getFiles(clientFiles);
      files.sort((a, b) => (a.timestamp < b.timestamp ? 1 : -1));
      this.setState({ files });
      if (files.length > 0)
        if (!this.state.pdf) this.choosePdf(`${files[0].path}.pdf`);
    }
  }

  componentWillUnmount() {
    this.serviceSubscription();
  }

  showDataErrorMessage() {
    // Create modal dialog container if it doesn't exist
    let $errorModal = $("#error-modal");
    if ($errorModal.length === 0) {
      $("body").append(`
        <div id="error-modal" style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.7);
          z-index: 9999;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        ">
          <div style="
            background-color: white;
            border-radius: 8px;
            padding: 20px;
            max-width: 80%;
            width: 320px;
            text-align: center;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          ">
            <h3 style="margin-top: 0; color: #d32f2f;">Error</h3>
            <p id="error-message" style="margin-bottom: 20px; color: #333;">Unable to load printer data. Please refresh the page and try again.</p>
            <button id="error-close-btn" style="
              background-color: #d32f2f;
              color: white;
              border: none;
              padding: 10px 20px;
              border-radius: 4px;
              cursor: pointer;
              font-weight: bold;
            ">Refresh Page</button>
          </div>
        </div>
      `);
      
      // Add event listener to refresh button
      $("#error-close-btn").on("click", function() {
        window.location.reload();
      });
      
      $errorModal = $("#error-modal");
    }
    
    // Show the modal
    $errorModal.css({
      "opacity": "1", 
      "pointer-events": "all"
    });
    
    // Set the error message
    $("#error-message").text("Unable to load printer data. Please refresh the page and try again.");

    // Set initializing to false when showing error
    this.setState({ initializing: false });
  }

  triggerErrorForTesting() {
    console.log("Manually triggering error message for testing");
    this.showDataErrorMessage();
  }

  render() {
    const spinner = (
      <div className="lds-ring">
        <span id="ring-progress">0</span>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );

    const gallery = [];
    for (const file of this.state.files) {
      gallery.push(
        <div
          key={file.id}
          onClick={() => this.choosePdf(`${file.path}.pdf`)}
          className="item"
        >
          <img src={file.thumbnail} />
          <span>{moment(file.timestamp).fromNow()}</span>
        </div>
      );
    }

    let status, printerState, scannerState;
    let printerAvailable = false;
    let scannerAvailable = false;
    if (
      this.state.service &&
      (this.state.service.printer || this.state.service.scanner)
    ) {
      if (this.state.service.printer) {
        let state, color;
        switch (this.state.service.printer.state.toLowerCase()) {
          case "idle":
            if (this.state.allowed) {
              state = "online";
              color = "#006400";
              printerAvailable = true;
            } else {
              state = "restricted";
              color = "#ed143d";
              printerAvailable = false;
            }
            break;
          case "stopped":
            state = "error";
            color = "#ed143d";
            break;
          case "processing":
            state = "processing";
            color = "#0080a2";
            break;
          default:
            state = "offline";
            color = "#ed143d";
            break;
        }
        printerState = (
          <div>
            <span>printer: </span>
            <span className="status-message" style={{ color }}>
              {state}
            </span>
          </div>
        );
      }
      if (this.state.service.scanner) {
        let state, color;
        switch (this.state.service.scanner.state.toLowerCase()) {
          case "idle":
            if (this.state.allowed) {
              state = "online";
              color = "#006400";
              scannerAvailable = true;
            } else {
              state = "restricted";
              color = "#ed143d";
              scannerAvailable = false;
            }
            break;
          case "stopped":
            state = "error";
            color = "#ed143d";
            break;
          case "processing":
            state = "processing";
            color = "#0080a2";
            break;
          default:
            state = "offline";
            color = "#ed143d";
            break;
        }
        scannerState = (
          <div>
            <span>scanner: </span>
            <span className="status-message" style={{ color }}>
              {state}
            </span>
          </div>
        );
      }
      status = (
        <div className="status">
          {printerState}
          {scannerState}
        </div>
      );
    }

    let page = (
      <div className="book-wrapper">
        <div className="book-menu">
          <label href="#" id="add-files" className="ripple">
            <input
              type="file"
              onChange={this.onChangeFile}
              style={{ display: "none" }}
            />
            <i
              className="fad fa-file-plus"
              style={{ pointerEvents: "none" }}
            ></i>
            <span style={{ pointerEvents: "none" }}> File</span>
          </label>
          {gallery.length > 0 && (
            <div className="gallery touchmove">{gallery}</div>
          )}
          {gallery.length === 0 && (
            <div className="gallery touchmove missing-files">
              <span>Choose files from your device to print</span>
            </div>
          )}
        </div>
        <div
          style={{
            display: "inline-block",
            width: "calc(100% - 100px)",
            height: "100%",
            background: "#ccc",
          }}
        >
          {this.state.pdf && (
            <div id="footer-menu" className="footer-menu-2-icons">
              <a href="#" className="ripple" onClick={() => this.save()}>
                <i className="fad fa-download"></i>
                <span>Save</span>
              </a>
              <a href="#" className="ripple" onClick={() => this.remove()}>
                <i className="fad fa-trash"></i>
                <span>Delete</span>
              </a>
            </div>
          )}

          <div id="book"></div>
        </div>
      </div>
    );
    let button = this.state.app.state.client ? (
      <div className="three-main-action-buttons" style={{ height: 49 + "px" }}>
        <div
          id="scan-button"
          onClick={() => this.action("scan")}
          href="#"
          className={`${scannerAvailable ? "" : "disabled "}${
            this.state.scan ? "button-progress " : ""
          }main-action-button button button-3d button-m button-full shadow-medium border-dark1-dark bg-dark1-light ripple notranslate`}
        >
          <span>
            scan{" "}
            {this.state.scan ? spinner : <i className="fal fa-scanner-image" />}
          </span>
        </div>
        <div
          id="copy-button"
          onClick={() => this.action("copy")}
          href="#"
          className={`${
            scannerAvailable && printerAvailable ? "" : "disabled "
          }${
            this.state.copy ? "button-progress " : ""
          }main-action-button button button-3d button-m button-full shadow-medium border-dark1-dark bg-dark1-light ripple notranslate`}
        >
          copy {this.state.copy ? spinner : <i className="fal fa-clone" />}
        </div>
        <div
          id="print-button"
          onClick={() => {
            this.settings.current.resetSettings();
            this.action("print");
            this.settings.current.resetSettings();
          }}
          href="#"
          style={{ height: 49 + "px", marginBottom: 0 }}
          className={`${
            this.state.allowed &&
            printerAvailable &&
            this.state.pdf &&
            this.state.pages
              ? ""
              : "disabled "
          }${
            this.state.print ? "button-progress " : ""
          }main-action-button button button-3d button-m button-full shadow-medium border-dark1-dark bg-dark1-light ripple notranslate`}
        >
          <span>
            print {this.state.print ? spinner : <i className="fal fa-print" />}
          </span>
        </div>
      </div>
    ) : null;

    const { loader, uploading, uploadProgress, converting } = this.state;

    if (loader && !uploading && !converting) {
      page = (
        <div
          className="demo-preloader"
          style={{ width: 100 + "%", height: 100 + "%" }}
        >
          <div className="preload-spinner preload-medium border-highlight"></div>
        </div>
      );
    } else if (uploading) {
      page = (
        <div
          className="demo-preloader"
          style={{ width: 100 + "%", height: 100 + "%" }}
        >
          <div className="preload-spinner preload-medium border-highlight"></div>
          <div className="loader-progress">Uploading {uploadProgress}%</div>
        </div>
      );
    } else if (converting) {
      page = (
        <div
          className="demo-preloader"
          style={{ width: 100 + "%", height: 100 + "%" }}
        >
          <div className="preload-spinner preload-medium border-highlight"></div>
          <div className="loader-progress">Preparing your file...</div>
        </div>
      );
    }

    const printer = helpers.fixPrinter(this.state.printer);
    const client = this.state.app.state.client;

    // Add initialization overlay
    const initializingOverlay = this.state.initializing ? (
      <div className="initialization-overlay" style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        zIndex: 9998,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        transition: "opacity 0.3s ease",
      }}>
        <div className="preload-spinner preload-large border-highlight" style={{
          marginBottom: "20px"
        }}></div>
        <div style={{
          fontSize: "18px",
          color: "#333",
          fontWeight: "500",
          textAlign: "center",
          padding: "0 20px"
        }}>
          Initializing printer services...
        </div>
      </div>
    ) : null;

    return (
      <div
        id="page"
        className={`${
          this.state.print || this.state.copy || this.state.scan
            ? "progress"
            : ""
        }`}
      >
        {initializingOverlay}
        <div className="header header-fixed header-logo-app no-shadow">
          <a href="#" className="header-title ultrabold notranslate">
            {this.state.computerUser.name}
          </a>
          <div
            className="header-icon header-icon-1"
            onClick={() => this.printerBack()}
          >
            <i className="far fa-arrow-left"></i>
          </div>
          <div className="header-icon header-icon-3">
            <a
              href="#"
              onClick={() => this.state.app.change("wallet")}
              style={{ fontSize: "16px" }}
            >
              <i className="fad fa-wallet"></i>
            </a>
          </div>
          {this.state.computerUser.pricing && (
            <div
              data-menu="menu-info-bottom"
              className="header-icon header-icon-2 header-icon-printer"
            >
              <i className="far fa-info-circle"></i>
            </div>
          )}
        </div>

        <Info printer={this} />
        <Settings
          ref={this.settings}
          printer={this}
          services={this.state.services}
          pages={this.state.pages}
          pdf={this.state.pdf}
          app={this.state.app}
          pricing={this.state.computerUser.pricing}
        />
        <JobFinished printer={this} finishedJob={this.state.finishedJob} />
        <JobFailed printer={this} failedJob={this.state.failedJob} />
        {this.state.computerUserRef && <ReloadBalance user={this.state.user} app={this.state.app} computerUserRef={this.state.computerUserRef} printCost={this.state.printCost} />}

        <div className={this.props.className}>
          {page}
          <div className="bottom">
            {button}
            <div className="printer">
              <img src={this.state.pic} />
              <div className="details notranslate">
                <span className="manufacturer">{printer.manufacturer}</span>
                <span className="model">{printer.model}</span>
              </div>
              {status}
            </div>
          </div>
        </div>
        <div className="menu-hider"></div>
        
        {/* Debug floating button - always visible in debug mode */}
        {window.location.search.includes('debug') && (
          <div id="debug-floating-button" style={{
            position: 'fixed',
            bottom: '80px',
            right: '20px',
            zIndex: 9999,
            backgroundColor: '#ff5722',
            color: 'white',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '24px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
            cursor: 'pointer'
          }} onClick={() => {
            if (window.mobileDebug) {
              window.mobileDebug("Manual debug triggered");
              window.mobileDebug("State dump:", {
                printerRef: this.state.printerRef ? "exists" : "missing",
                service: this.state.service ? "exists" : "missing",
                services: this.state.services ? "exists" : "missing",
                computerUser: this.state.computerUser ? "exists" : "missing"
              });
              
              // Force retry of Firebase connection
              this.testFirebaseConnectivity();
            }
          }}>
            <i className="fal fa-bug"></i>
          </div>
        )}
      </div>
    );
  }
}

export default Printer;



// WEBPACK FOOTER //
// ./src/components/pages/printer/index.js